import { createRouter } from '@tanstack/react-router'
import { routeTree } from '~/routeTree.gen'
import * as TanstackQuery from './integrations/tanstack-query/root-provider'

export const getRouter = () => {
  const rqContext = TanstackQuery.getContext()

  const router = createRouter({
    routeTree,
    context: { ...rqContext },
    defaultPreload: 'intent',
    Wrap: (props: { children: React.ReactNode }) => {
      return <TanstackQuery.Provider {...rqContext}>{props.children}</TanstackQuery.Provider>
    },
  })

  return router
}
